export function dataInRequest(params = {}) {
  return {
    type: '@vazaoEquipamentosBicos/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@vazaoEquipamentosBicos/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@vazaoEquipamentosBicos/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@vazaoEquipamentosBicos/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@vazaoEquipamentosBicos/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@vazaoEquipamentosBicos/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@vazaoEquipamentosBicos/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@vazaoEquipamentosBicos/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@vazaoEquipamentosBicos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@vazaoEquipamentosBicos/RECORD_FILTERING',
    payload: { params },
  };
}
